import { connectPagination } from 'instantsearch.js/es/connectors';

// Render custom pagination widget
// https://www.algolia.com/doc/api-reference/widgets/pagination/js/#connector
export const customPagination = connectPagination(function(renderOptions) {
  const { currentRefinement, nbPages, isFirstPage, isLastPage, refine, createURL, widgetParams } =
    renderOptions;

  const container = widgetParams.container;

  // Hide pagination if no results
  container.classList.toggle('visually-hidden', nbPages === 0);

  const currentPage = currentRefinement + 1;
  const totalPages = nbPages === 0 ? 1 : nbPages;

  container.innerHTML = `
      <div class="algolia-pagination__pages" aria-label="${currentPage} of ${totalPages} pages">
        ${currentPage} / ${totalPages}
      </div>
      <div class="algolia-pagination__arrows ${
        nbPages <= 1 ? 'algolia-pagination__arrows--disabled' : ''
      }">
        <a
          class="algolia-pagination__arrow algolia-pagination__arrow--prev ${
            isFirstPage ? 'algolia-pagination__arrow--disabled' : ''
          }"
          href="${createURL(currentRefinement - 1)}"
          data-value="${currentRefinement - 1}"
        >
          <span class="visually-hidden">Previous page</span>
          <svg aria-hidden="true" focusable="false">
            <use xlink:href="#arrow-left"></use>
          </svg>
        </a>
        <a
          class="algolia-pagination__arrow algolia-pagination__arrow--next ${
            isLastPage ? 'algolia-pagination__arrow--disabled' : ''
          }"
          href="${createURL(currentRefinement + 1)}"
          data-value="${currentRefinement + 1}"
        >
          <span class="visually-hidden">Next page</span>
          <svg aria-hidden="true" focusable="false">
            <use xlink:href="#arrow-right"></use>
          </svg>
        </a>
      </div>
    `;

  [...container.querySelectorAll('a')].forEach(element => {
    element.addEventListener('click', event => {
      event.preventDefault();
      refine(event.currentTarget.dataset.value);
    });
  });
});
